/**
 * Custom Boxes Carousel Cova - JavaScript
 */

class CustomBoxesSectionCova {
  constructor(section) {
    this.section = section;
    this.carousel = section.querySelector('.js-selection-section-carousel');
    this.carouselContainer = section.querySelector('.selection-section__carousel-container');
    this.wrapper = section.querySelector('.carousel__wrapper');
    this.slides = section.querySelectorAll('.carousel__slide');
    this.prevBtn = section.querySelector('.js-stepper-arrows-prev');
    this.nextBtn = section.querySelector('.js-stepper-arrows-next');
    this.rollerCounter = section.querySelector('.js-pagination-counter');
    this.totalCounter = section.querySelector('.swiper-pagination-total');
    this.heading = section.querySelector('.selection-section__heading');
    this.arrowsContainer = section.querySelector('.stepper-arrows');

    this.currentIndex = 0;
    this.totalSlides = this.slides.length;
    this.scrollProgress = 0;
    this.maxScroll = 0;
    this.isCarouselActive = false;
    this.isTransitioning = false;

    // Variabili per drag fluido
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.velocity = 0;
    this.lastX = 0;
    this.lastTime = 0;

    this.init();
  }

  init() {
    if (!this.wrapper || this.slides.length === 0) return;

    // Inizializza lo stato iniziale
    this.section.setAttribute('data-carousel-active', 'false');
    this.isCarouselActive = false;

    this.calculateMaxScroll();
    this.setupEventListeners();
    this.setupScrollVisibility();
    this.updateNavigation();
    this.updateTransformEffect();

    // Inizializza il counter con il valore corretto
    if (this.rollerCounter) {
      this.rollerCounter.textContent = '1';
    }
    if (this.totalCounter) {
      this.totalCounter.textContent = this.totalSlides;
    }

    // Aggiorna al resize (ma non se il carousel è attivo)
    window.addEventListener('resize', this.debounce(() => {
      const isActive = this.section.getAttribute('data-carousel-active') === 'true';
      if (!isActive) {
        this.calculateMaxScroll();
        this.updateNavigation();
      }
    }, 250));
  }

  calculateMaxScroll() {
    // Calcola lo scroll massimo del carousel
    // IMPORTANTE: Calcola sempre basandosi sullo stato iniziale (30% width)
    if (!this.initialMaxScroll) {
      this.initialMaxScroll = this.wrapper.scrollWidth - this.wrapper.clientWidth;
    }
    this.maxScroll = this.wrapper.scrollWidth - this.wrapper.clientWidth;
  }

  setupEventListeners() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prev());
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.next());
    }

    // Mouse drag support - Funziona su tutto il carousel container, anche sui prodotti
    const handleMouseDown = (e) => {
      // Ignora solo i pulsanti di navigazione
      if (e.target.closest('.stepper-arrows')) return;

      // Blocca drag durante transizioni
      if (this.isTransitioning) return;

      this.isDragging = true;
      this.hasMoved = false; // Flag per distinguere click da drag
      this.startX = e.pageX;
      this.startY = e.pageY;
      this.scrollLeft = this.wrapper.scrollLeft;
      this.lastX = e.pageX;
      this.lastTime = Date.now();
      this.velocity = 0;

      this.carouselContainer.style.cursor = 'grabbing';
      this.wrapper.style.scrollBehavior = 'auto'; // Disabilita smooth scroll durante drag

      // Previeni selezione testo
      e.preventDefault();
    };

    const handleMouseMove = (e) => {
      if (!this.isDragging) return;
      if (this.isTransitioning) return;

      const deltaX = Math.abs(e.pageX - this.startX);
      const deltaY = Math.abs(e.pageY - this.startY);

      // Se si è mosso più di 5px, considera come drag (non click)
      if (deltaX > 5 || deltaY > 5) {
        this.hasMoved = true;
      }

      e.preventDefault();

      const currentTime = Date.now();
      const deltaTime = currentTime - this.lastTime;
      const deltaXVelocity = e.pageX - this.lastX;

      // Calcola velocità per momentum
      if (deltaTime > 0) {
        this.velocity = deltaXVelocity / deltaTime;
      }

      this.lastX = e.pageX;
      this.lastTime = currentTime;

      const x = e.pageX;
      const walk = (x - this.startX) * 1.5; // Sensibilità aumentata
      const newScrollLeft = this.scrollLeft - walk;

      // Limita lo scroll: non andare oltre l'ultima slide
      const maxScroll = this.wrapper.scrollWidth - this.wrapper.clientWidth;
      const clampedScrollLeft = Math.max(0, Math.min(newScrollLeft, maxScroll));

      this.wrapper.scrollLeft = clampedScrollLeft;
    };

    const handleMouseUp = (e) => {
      if (!this.isDragging) return;

      this.isDragging = false;
      this.carouselContainer.style.cursor = 'grab';
      this.wrapper.style.scrollBehavior = 'smooth';

      // Se è stato un drag (non un semplice click), previeni il click sui link
      if (this.hasMoved) {
        e.preventDefault();
        e.stopPropagation();

        // Controlla se siamo molto vicini alla slide 0 dopo il drag
        const scrollLeft = this.wrapper.scrollLeft;
        const isNearStart = scrollLeft < 50;

        if (isNearStart && window.innerWidth >= 1024 && this.isCarouselActive) {
          // Snap a 0 e torna allo stato iniziale
          this.wrapper.scrollTo({
            left: 0,
            behavior: 'smooth'
          });

          setTimeout(() => {
            this.handleReturnToInitialState();
          }, 400);
        } else {
          // Applica momentum/inertia normale
          this.applyMomentum();
        }
      }

      this.hasMoved = false;
    };

    // Previeni click sui link se c'è stato un drag
    const handleClick = (e) => {
      if (this.hasMoved) {
        e.preventDefault();
        e.stopPropagation();
        this.hasMoved = false;
      }
    };

    // Aggiungi eventi al carousel container (non solo al wrapper)
    this.carouselContainer.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    this.carouselContainer.addEventListener('click', handleClick, true); // Capture phase

    // Imposta cursor grab di default
    this.carouselContainer.style.cursor = 'grab';

    // Touch events
    let touchStartX = 0;
    let touchScrollLeft = 0;

    this.wrapper.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].pageX;
      touchScrollLeft = this.wrapper.scrollLeft;
    }, { passive: true });

    this.wrapper.addEventListener('touchmove', (e) => {
      if (this.isTransitioning) return;
      const touchX = e.touches[0].pageX;
      const walk = (touchStartX - touchX);
      const newScrollLeft = touchScrollLeft + walk;

      // Limita lo scroll: non andare oltre l'ultima slide
      const maxScroll = this.wrapper.scrollWidth - this.wrapper.clientWidth;
      const clampedScrollLeft = Math.max(0, Math.min(newScrollLeft, maxScroll));

      this.wrapper.scrollLeft = clampedScrollLeft;
    }, { passive: true });

    this.wrapper.addEventListener('touchend', (e) => {
      // Mobile: swipe = vai alla slide successiva/precedente come con le arrows
      const touchEndX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].pageX : touchStartX;
      const deltaX = touchStartX - touchEndX; // >0 = swipe verso sinistra (next)
      const MIN_SWIPE = 10; // px
      const maxIndex = this.totalSlides - 1;

      if (Math.abs(deltaX) < MIN_SWIPE) {
        // Spostamento minimo: resta sulla slide corrente (snap al vicino)
        this.snapToNearestSlide();
        return;
      }

      if (deltaX > 0 && this.currentIndex < maxIndex) {
        // Swipe a sinistra: next
        this.currentIndex++;
        this.scrollToIndex(this.currentIndex);
        this.updateCounter(this.currentIndex + 1);
      } else if (deltaX < 0 && this.currentIndex > 0) {
        // Swipe a destra: prev
        this.currentIndex--;
        this.scrollToIndex(this.currentIndex);
        this.updateCounter(this.currentIndex + 1);
      } else {
        this.snapToNearestSlide();
      }
    });

    // CHIAVE DIOR: Update transform effect on scroll (real-time)
    this.wrapper.addEventListener('scroll', () => {
      this.updateTransformEffect();
      this.updateCurrentIndexFromScroll();
    }, { passive: true });
  }

  prev() {
    const isMobile = window.innerWidth < 1024;

    if (isMobile) {
      // Su mobile: navigazione semplice
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.scrollToIndex(this.currentIndex);
        this.updateCounter(this.currentIndex + 1);
      }
    } else {
      // Su desktop: logica con carousel attivo
      if (this.isCarouselActive) {
        // Blocca durante transizioni
        if (this.isTransitioning) {
          return;
        }

        // Se il carousel è attivo, vai alla slide precedente
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.scrollToIndex(this.currentIndex);
          this.updateCounter(this.currentIndex + 1);

          // Se torniamo alla slide 0, disattiva il carousel
          if (this.currentIndex === 0) {
            this.isTransitioning = true;

            // Scrolla prima alla slide 0
            this.wrapper.scrollTo({
              left: 0,
              behavior: 'smooth'
            });

            // Dopo lo scroll, disattiva il carousel
            setTimeout(() => {
              this.isCarouselActive = false;
              this.section.classList.remove('is-scrolling');
              this.section.setAttribute('data-carousel-active', 'false');

              // Ricalcola dopo la transizione CSS
              setTimeout(() => {
                this.calculateMaxScroll();
                this.updateNavigation();
                this.isTransitioning = false;
              }, 700);
            }, 600);
          }
        }
      }
      // Se il carousel non è attivo, non fare nulla (prev è disabilitato)
    }
  }

  next() {
    const maxIndex = this.totalSlides - 1;
    const isMobile = window.innerWidth < 1024;

    if (isMobile) {
      // Su mobile: navigazione semplice
      if (this.currentIndex < maxIndex) {
        this.currentIndex++;
        this.scrollToIndex(this.currentIndex);
        this.updateCounter(this.currentIndex + 1);
      }
    } else {
      // Su desktop: gestione transizione stato 1 → stato 2
      if (!this.isCarouselActive) {
        // IMPORTANTE: Blocca ulteriori click durante la transizione
        if (this.isTransitioning) {
          return;
        }

        this.isTransitioning = true;

        // Disabilita temporaneamente lo scroll listener per evitare conflitti
        this.wrapper.style.pointerEvents = 'none';

        // Se il carousel NON è attivo, attivalo (espandi al 100%)
        this.isCarouselActive = true;
        this.section.classList.add('is-scrolling');
        this.section.setAttribute('data-carousel-active', 'true');

        // Vai alla slide 1 (indice 1) invece di 3
        const targetIndex = 1;

        // Aspetta che la transizione CSS sia completata (600ms + buffer)
        setTimeout(() => {
          // Ricalcola le dimensioni dopo la transizione
          this.calculateMaxScroll();

          // Scrolla alla slide target
          const slide = this.slides[targetIndex];
          if (slide) {
            const containerPadding = 60; // Padding quando carousel è attivo
            const scrollLeft = Math.max(0, slide.offsetLeft - containerPadding);

            this.wrapper.scrollTo({
              left: scrollLeft,
              behavior: 'smooth'
            });
          }

          this.currentIndex = targetIndex;
          this.updateCounter(this.currentIndex + 1);
          this.updateNavigation();

          // Riabilita pointer events dopo lo scroll
          setTimeout(() => {
            this.wrapper.style.pointerEvents = '';
            this.isTransitioning = false;
          }, 600); // Tempo per completare lo scroll smooth
        }, 700);
      } else {
        // Se il carousel è già attivo, navigazione normale
        if (this.currentIndex < maxIndex) {
          this.currentIndex++;
          this.scrollToIndex(this.currentIndex);
          this.updateCounter(this.currentIndex + 1);
        }
      }
    }
  }



  applyMomentum() {
    // Applica effetto momentum/inertia dopo il rilascio del mouse
    const momentumStrength = 15; // Forza del momentum
    const friction = 0.95; // Attrito (0-1, più alto = meno attrito)
    let currentVelocity = this.velocity * momentumStrength;

    const animate = () => {
      if (Math.abs(currentVelocity) < 0.1) {
        // Momentum terminato, snap alla slide più vicina
        this.snapToNearestSlide();
        return;
      }

      const maxScroll = this.wrapper.scrollWidth - this.wrapper.clientWidth;
      const newScrollLeft = this.wrapper.scrollLeft - currentVelocity;
      const clampedScrollLeft = Math.max(0, Math.min(newScrollLeft, maxScroll));

      this.wrapper.scrollLeft = clampedScrollLeft;

      // Se abbiamo raggiunto i limiti, ferma il momentum
      if (clampedScrollLeft === 0 || clampedScrollLeft === maxScroll) {
        this.snapToNearestSlide();

        // Se siamo tornati a scrollLeft = 0 su desktop, disattiva il carousel
        if (clampedScrollLeft === 0 && window.innerWidth >= 1024 && this.isCarouselActive) {
          this.handleReturnToInitialState();
        }
        return;
      }

      currentVelocity *= friction;
      requestAnimationFrame(animate);
    };

    // Avvia animazione solo se c'è velocità significativa
    if (Math.abs(currentVelocity) > 0.5) {
      requestAnimationFrame(animate);
    } else {
      this.snapToNearestSlide();

      // Controlla se dobbiamo tornare allo stato iniziale
      if (this.wrapper.scrollLeft < 10 && window.innerWidth >= 1024 && this.isCarouselActive) {
        this.handleReturnToInitialState();
      }
    }
  }

  handleReturnToInitialState() {
    // Gestisce il ritorno allo stato iniziale (stato 2 → stato 1)
    if (this.isTransitioning) return;

    this.isTransitioning = true;
    this.currentIndex = 0;
    this.updateCounter(1);

    // Disattiva il carousel
    this.isCarouselActive = false;
    this.section.classList.remove('is-scrolling');
    this.section.setAttribute('data-carousel-active', 'false');

    // Ricalcola dopo la transizione CSS
    setTimeout(() => {
      this.calculateMaxScroll();
      this.updateNavigation();
      this.isTransitioning = false;
    }, 700);
  }

  snapToNearestSlide() {
    // Trova la slide più vicina e snap ad essa
    const scrollLeft = this.wrapper.scrollLeft;

    // Calcola l'indice basandosi sulla posizione di ogni slide
    let nearestIndex = 0;
    let minDistance = Infinity;

    this.slides.forEach((slide, index) => {
      const slideLeft = slide.offsetLeft;
      const distance = Math.abs(scrollLeft - slideLeft);

      if (distance < minDistance) {
        minDistance = distance;
        nearestIndex = index;
      }
    });

    const clampedIndex = Math.max(0, Math.min(nearestIndex, this.totalSlides - 1));

    // Scroll alla slide più vicina
    this.currentIndex = clampedIndex;
    this.scrollToIndex(this.currentIndex);
    this.updateCounter(this.currentIndex + 1);

    // Aggiorna lo stato del layout basato sulla slide corrente
    setTimeout(() => {
      this.updateTransformEffect();
      this.updateNavigation();
    }, 100);
  }

  scrollToIndex(index) {
    if (!this.slides[index]) {
      return;
    }

    const slide = this.slides[index];
    // IMPORTANTE: Il padding cambia in base allo stato del carousel
    // - Carousel NON attivo: padding-left = 0
    // - Carousel attivo: padding-left = 60px
    const containerPadding = window.innerWidth >= 1024
      ? (this.isCarouselActive ? 60 : 0)
      : 20;
    let scrollLeft = slide.offsetLeft - containerPadding;

    // OTTIMIZZAZIONE: Quando il carousel è attivo e siamo sulla prima slide,
    // scrolla a 0 per mostrare completamente il primo box
    if (this.isCarouselActive && index === 0 && window.innerWidth >= 1024) {
      scrollLeft = 0;
    }

    scrollLeft = Math.max(0, scrollLeft);

    this.wrapper.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });

    this.updateNavigation();
    // Il counter viene aggiornato automaticamente da updateCurrentIndexFromScroll
  }

  updateCurrentIndexFromScroll() {
    const scrollLeft = this.wrapper.scrollLeft;

    // IMPORTANTE: Se scrollLeft è molto piccolo (< 10px), considera come slide 0
    // Questo evita problemi di arrotondamento su risoluzioni alte
    if (scrollLeft < 10) {
      if (this.currentIndex !== 0) {
        this.currentIndex = 0;
        this.updateNavigation();
        this.updateCounter(1);
        this.updateTransformEffect();
      }
      return;
    }

    // Trova la slide più vicina basandosi sulla posizione effettiva
    let nearestIndex = 0;
    let minDistance = Infinity;

    this.slides.forEach((slide, index) => {
      const slideLeft = slide.offsetLeft;
      const containerPadding = window.innerWidth >= 1024
        ? (this.isCarouselActive ? 60 : 0)
        : 20;
      const adjustedSlideLeft = slideLeft - containerPadding;
      const distance = Math.abs(scrollLeft - adjustedSlideLeft);

      if (distance < minDistance) {
        minDistance = distance;
        nearestIndex = index;
      }
    });

    // Aggiorna l'indice solo se è cambiato
    if (nearestIndex !== this.currentIndex) {
      this.currentIndex = nearestIndex;
      this.updateNavigation();

      // LOGICA COUNTER: Mostra sempre l'indice reale della slide
      this.updateCounter(this.currentIndex + 1);

      // IMPORTANTE: Aggiorna lo stato del layout quando cambia slide
      this.updateTransformEffect();
    }
  }

  updateNavigation() {
    const maxIndex = this.totalSlides - 1;
    const isCarouselActive = this.isCarouselActive;
    const isMobile = window.innerWidth < 1024;

    // Update buttons
    if (this.prevBtn) {
      if (isMobile) {
        // Su mobile: prev disabilitato solo se siamo alla prima slide
        this.prevBtn.disabled = this.currentIndex === 0;
        if (this.currentIndex === 0) {
          this.prevBtn.classList.add('stepper-arrows__button--disabled');
        } else {
          this.prevBtn.classList.remove('stepper-arrows__button--disabled');
        }
      } else {
        // Su desktop: logica con carousel attivo/non attivo
        if (isCarouselActive) {
          // Quando il carousel è attivo (100% width):
          // Prev sempre abilitato (per tornare alla slide 1)
          this.prevBtn.disabled = false;
          this.prevBtn.classList.remove('stepper-arrows__button--disabled');
        } else {
          // Quando il carousel NON è attivo (layout 35%-35%-30%):
          // Prev sempre disabilitato (siamo sulla slide 1)
          this.prevBtn.disabled = true;
          this.prevBtn.classList.add('stepper-arrows__button--disabled');
        }
      }
    }

    if (this.nextBtn) {
      if (isMobile) {
        // Su mobile: next disabilitato solo se siamo all'ultima slide
        this.nextBtn.disabled = this.currentIndex >= maxIndex;
        if (this.currentIndex >= maxIndex) {
          this.nextBtn.classList.add('stepper-arrows__button--disabled');
        } else {
          this.nextBtn.classList.remove('stepper-arrows__button--disabled');
        }
      } else {
        // Su desktop: logica con carousel attivo/non attivo
        if (isCarouselActive) {
          // Quando il carousel è attivo:
          // Next disabilitato solo se siamo all'ultima slide
          if (this.currentIndex >= maxIndex) {
            this.nextBtn.disabled = true;
            this.nextBtn.classList.add('stepper-arrows__button--disabled');
          } else {
            this.nextBtn.disabled = false;
            this.nextBtn.classList.remove('stepper-arrows__button--disabled');
          }
        } else {
          // Quando il carousel NON è attivo:
          // Next sempre abilitato (per attivare il carousel)
          this.nextBtn.disabled = false;
          this.nextBtn.classList.remove('stepper-arrows__button--disabled');
        }
      }
    }

    // Update pagination
    if (this.totalCounter) {
      this.totalCounter.textContent = this.totalSlides;
    }
  }

  updateCounter(value) {
    if (this.rollerCounter) {
      // Animazione rolling del counter
      this.rollerCounter.style.transform = 'translateY(-5px)';
      this.rollerCounter.style.opacity = '0';

      setTimeout(() => {
        this.rollerCounter.textContent = value;
        this.rollerCounter.style.transform = 'translateY(0)';
        this.rollerCounter.style.opacity = '1';
      }, 150);
    }
  }

  /**
   * Visibilità arrow gestita solo via CSS per allineamento con product-selection.
   */
  setupScrollVisibility() {
    // No-op: lasciamo al CSS la gestione della visibilità e del posizionamento
  }

  /**
   * EFFETTO SEMPLIFICATO: Attiva/disattiva lo stato del carousel
   * Layout: 45% + 55% → 0% + 100%
   */
  updateTransformEffect() {
    // Solo su desktop
    if (window.innerWidth < 1024) return;

    // Evita loop durante le transizioni
    if (this.isTransitioning) {
      return;
    }

    // Determina se siamo sulla prima slide
    const isOnFirstSlide = this.currentIndex === 0;

    // Attiva lo slider se NON siamo sulla prima slide
    const shouldActivateSlider = !isOnFirstSlide;

    // Cambia stato solo se necessario
    if (shouldActivateSlider && !this.isCarouselActive) {
      this.isTransitioning = true;
      this.isCarouselActive = true;

      // Attiva lo stato espanso
      this.section.classList.add('is-scrolling');
      this.section.setAttribute('data-carousel-active', 'true');

      // Reset della transizione dopo l'animazione
      setTimeout(() => {
        this.isTransitioning = false;
        this.calculateMaxScroll();
        this.updateNavigation();
      }, 650); // Leggermente più lungo della transizione CSS (600ms)

    } else if (!shouldActivateSlider && this.isCarouselActive) {
      this.isTransitioning = true;
      this.isCarouselActive = false;

      // Disattiva lo stato espanso
      this.section.classList.remove('is-scrolling');
      this.section.setAttribute('data-carousel-active', 'false');

      // Reset della transizione dopo l'animazione
      setTimeout(() => {
        this.isTransitioning = false;
        this.calculateMaxScroll();
      }, 650);
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Initialize all custom boxes sections
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.selection-section--custom-boxes.js-selection-section');
  sections.forEach(section => {
    new CustomBoxesSectionCova(section);
  });
});

// Shopify theme editor support
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.selection-section--custom-boxes.js-selection-section');
    if (section) {
      new CustomBoxesSectionCova(section);
    }
  });

  document.addEventListener('shopify:section:unload', () => {
    // Cleanup if needed
  });
}

// Initialize all custom boxes sections
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.selection-section--custom-boxes.js-selection-section');
  sections.forEach(section => {
    new CustomBoxesSectionCova(section);
  });
});

// Shopify theme editor support
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.selection-section--custom-boxes.js-selection-section');
    if (section) {
      new CustomBoxesSectionCova(section);
    }
  });

  document.addEventListener('shopify:section:unload', () => {
    // Cleanup if needed
  });
}
